(function () {
  'use strict';

  var root = document.querySelector('[data-devid-assistant-v2]');
  if (!root) return;

  var launcher = root.querySelector('[data-assistant-launcher]');
  var backdrop = root.querySelector('[data-assistant-backdrop]');
  var panel = root.querySelector('[data-assistant-panel]');
  var closeButton = root.querySelector('[data-assistant-close]');
  var resetButton = root.querySelector('[data-assistant-reset]');
  var form = root.querySelector('[data-assistant-form]');
  var input = root.querySelector('[data-assistant-input]');
  var sendButton = root.querySelector('[data-assistant-send]');
  var messagesNode = root.querySelector('[data-assistant-messages]');
  var liveNode = root.querySelector('[data-assistant-live]');
  var quickStrip = root.querySelector('[data-assistant-quick-strip]');

  if (!launcher || !panel || !form || !input || !messagesNode) return;

  var endpoint = (root.getAttribute('data-endpoint') || '').trim();
  var locale = (root.getAttribute('data-locale') || 'it-IT').trim();
  var language = (root.getAttribute('data-language') || locale || 'it').trim();
  var country = (root.getAttribute('data-country') || '').trim();
  var pageType = (root.getAttribute('data-page-type') || '').trim();
  var isEnglish = language.toLowerCase().indexOf('en') === 0 || locale.toLowerCase().indexOf('en') === 0;
  var previousFocus = null;
  var typingNode = null;

  var copy = isEnglish ? {
    error: 'I could not complete the request right now. Please try again in a moment.',
    invalid: 'I received an invalid response. Please try again.',
    loading: 'I am checking…',
    viewProduct: 'View product',
    openLink: 'Open',
    available: 'Available',
    unavailable: 'Unavailable',
    reset: 'The conversation has been reset.'
  } : {
    error: 'Non riesco a completare la richiesta in questo momento. Riprova tra poco.',
    invalid: 'Ho ricevuto una risposta non valida. Riprova.',
    loading: 'Sto verificando…',
    viewProduct: 'Vedi prodotto',
    openLink: 'Apri',
    available: 'Disponibile',
    unavailable: 'Non disponibile',
    reset: 'La conversazione è stata azzerata.'
  };

  var state = {
    open: false,
    busy: false,
    messages: [],
    conversationState: null
  };

  function emit(name, detail) {
    var payload = Object.assign({ event: name, assistant: 'devid_assistant_v2' }, detail || {});
    window.dispatchEvent(new CustomEvent('devid:assistant', { detail: payload }));
    if (Array.isArray(window.dataLayer)) window.dataLayer.push(payload);
  }

  function announce(text) {
    if (!liveNode) return;
    liveNode.textContent = '';
    window.setTimeout(function () { liveNode.textContent = text || ''; }, 20);
  }

  function setOpen(shouldOpen) {
    state.open = Boolean(shouldOpen);
    root.classList.toggle('is-open', state.open);
    document.body.classList.toggle('devid-assistant-v2-open', state.open);
    launcher.setAttribute('aria-expanded', state.open ? 'true' : 'false');
    panel.setAttribute('aria-hidden', state.open ? 'false' : 'true');

    if (state.open) {
      previousFocus = document.activeElement;
      panel.hidden = false;
      if (backdrop) backdrop.hidden = false;
      window.setTimeout(function () {
        panel.focus({ preventScroll: true });
        input.focus({ preventScroll: true });
      }, 30);
      emit('assistant_opened', { page_type: pageType || 'unknown' });
    } else {
      panel.hidden = true;
      if (backdrop) backdrop.hidden = true;
      if (previousFocus && typeof previousFocus.focus === 'function') previousFocus.focus({ preventScroll: true });
      emit('assistant_closed');
    }
  }

  function setBusy(isBusy) {
    state.busy = Boolean(isBusy);
    input.disabled = state.busy;
    if (sendButton) sendButton.disabled = state.busy;
    panel.setAttribute('aria-busy', state.busy ? 'true' : 'false');
  }

  function scrollToLatest() {
    var content = root.querySelector('[data-assistant-content]');
    if (!content) return;
    window.requestAnimationFrame(function () {
      content.scrollTop = content.scrollHeight;
    });
  }

  function safeUrl(value) {
    if (!value || typeof value !== 'string') return '';
    try {
      var parsed = new URL(value, window.location.origin);
      if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') return '';
      if (parsed.origin === window.location.origin) return parsed.pathname + parsed.search + parsed.hash;
      return parsed.href;
    } catch (error) {
      return '';
    }
  }

  function appendUserMessage(text) {
    var article = document.createElement('article');
    article.className = 'devid-assistant-v2__message devid-assistant-v2__message--user';

    var bubble = document.createElement('div');
    bubble.className = 'devid-assistant-v2__bubble';
    bubble.textContent = text;

    article.appendChild(bubble);
    messagesNode.appendChild(article);
    scrollToLatest();
  }

  function appendTyping() {
    removeTyping();
    var article = document.createElement('article');
    article.className = 'devid-assistant-v2__message devid-assistant-v2__message--assistant';
    article.setAttribute('data-assistant-typing', '');

    var bubble = document.createElement('div');
    bubble.className = 'devid-assistant-v2__bubble';
    bubble.setAttribute('aria-label', copy.loading);

    var dots = document.createElement('span');
    dots.className = 'devid-assistant-v2__typing';
    dots.innerHTML = '<span></span><span></span><span></span>';
    bubble.appendChild(dots);
    article.appendChild(bubble);
    messagesNode.appendChild(article);
    typingNode = article;
    announce(copy.loading);
    scrollToLatest();
  }

  function removeTyping() {
    if (typingNode && typingNode.parentNode) typingNode.parentNode.removeChild(typingNode);
    typingNode = null;
  }

  function normalizeAvailability(value) {
    if (!value) return '';
    if (typeof value === 'string') return value;
    if (typeof value === 'object' && typeof value.available === 'boolean') return value.available ? copy.available : copy.unavailable;
    return '';
  }

  function collectProducts(response) {
    var products = [];
    ['recommended_products', 'devid_label_alternatives', 'cross_sell', 'products'].forEach(function (key) {
      if (Array.isArray(response && response[key])) products = products.concat(response[key]);
    });

    var seen = {};
    return products.filter(function (product) {
      if (!product || typeof product !== 'object') return false;
      var key = product.url || product.handle || product.title || product.label;
      if (!key || seen[key]) return false;
      seen[key] = true;
      return Boolean(safeUrl(product.url));
    }).slice(0, 8);
  }

  function buildProductCard(product) {
    var card = document.createElement('article');
    card.className = 'devid-assistant-v2__product';

    var destination = safeUrl(product.url);
    var title = product.title || product.label || '';
    var image = product.image || product.image_url || '';

    if (image) {
      var mediaLink = document.createElement('a');
      mediaLink.className = 'devid-assistant-v2__product-media';
      mediaLink.href = destination;
      mediaLink.addEventListener('click', function () {
        emit('assistant_product_clicked', { vendor: product.vendor || '', handle: product.handle || '' });
      });

      var img = document.createElement('img');
      img.src = image;
      img.alt = product.image_alt || product.imageAlt || title;
      img.loading = 'lazy';
      img.decoding = 'async';
      mediaLink.appendChild(img);
      card.appendChild(mediaLink);
    }

    var body = document.createElement('div');
    body.className = 'devid-assistant-v2__product-body';

    if (product.vendor) {
      var vendor = document.createElement('p');
      vendor.className = 'devid-assistant-v2__product-vendor';
      vendor.textContent = product.vendor;
      body.appendChild(vendor);
    }

    var titleLink = document.createElement('a');
    titleLink.className = 'devid-assistant-v2__product-title';
    titleLink.href = destination;
    titleLink.textContent = title;
    titleLink.addEventListener('click', function () {
      emit('assistant_product_clicked', { vendor: product.vendor || '', handle: product.handle || '' });
    });
    body.appendChild(titleLink);

    if (product.price || product.compare_at_price || product.discount) {
      var price = document.createElement('p');
      price.className = 'devid-assistant-v2__product-price';
      if (product.price) {
        var strong = document.createElement('strong');
        strong.textContent = product.price;
        price.appendChild(strong);
      }
      if (product.compare_at_price) {
        var oldPrice = document.createElement('s');
        oldPrice.textContent = product.compare_at_price;
        price.appendChild(oldPrice);
      }
      if (product.discount) {
        var discount = document.createElement('span');
        discount.textContent = product.discount;
        price.appendChild(discount);
      }
      body.appendChild(price);
    }

    var availability = normalizeAvailability(product.availability);
    if (availability) {
      var availabilityNode = document.createElement('p');
      availabilityNode.className = 'devid-assistant-v2__product-reason';
      availabilityNode.textContent = availability;
      body.appendChild(availabilityNode);
    } else if (product.reason || product.message) {
      var reason = document.createElement('p');
      reason.className = 'devid-assistant-v2__product-reason';
      reason.textContent = product.reason || product.message;
      body.appendChild(reason);
    }

    var cta = document.createElement('a');
    cta.className = 'devid-assistant-v2__product-link';
    cta.href = destination;
    cta.textContent = copy.viewProduct;
    cta.addEventListener('click', function () {
      emit('assistant_product_clicked', { vendor: product.vendor || '', handle: product.handle || '' });
    });
    body.appendChild(cta);

    card.appendChild(body);
    return card;
  }

  function appendProducts(stack, response) {
    var products = collectProducts(response);
    if (!products.length) return;
    var rail = document.createElement('div');
    rail.className = 'devid-assistant-v2__products';
    rail.setAttribute('role', 'list');
    products.forEach(function (product) {
      var card = buildProductCard(product);
      card.setAttribute('role', 'listitem');
      rail.appendChild(card);
    });
    stack.appendChild(rail);
  }

  function appendPrimaryCta(stack, response) {
    var ctaData = response && response.primary_cta;
    if (!ctaData || !ctaData.url) return;
    var destination = safeUrl(ctaData.url);
    if (!destination) return;

    var row = document.createElement('div');
    row.className = 'devid-assistant-v2__cta-row';
    var cta = document.createElement('a');
    cta.className = 'devid-assistant-v2__cta';
    cta.href = destination;
    cta.textContent = ctaData.label || copy.openLink;
    cta.addEventListener('click', function () {
      emit('assistant_cta_clicked', { response_type: response.type || '' });
    });
    row.appendChild(cta);
    stack.appendChild(row);
  }

  function appendTracking(stack, response) {
    var lookup = response && response.order_lookup;
    var details = lookup && lookup.details;
    if (!details || !Array.isArray(details.tracking_items) || !details.tracking_items.length) return;

    var list = document.createElement('div');
    list.className = 'devid-assistant-v2__tracking-list';
    details.tracking_items.forEach(function (item, index) {
      var destination = safeUrl(item && item.url);
      if (!destination) return;
      var link = document.createElement('a');
      link.className = 'devid-assistant-v2__tracking-link';
      link.href = destination;
      link.target = '_blank';
      link.rel = 'noopener';
      link.textContent = (item.company || (isEnglish ? 'Shipment' : 'Spedizione')) + (details.tracking_items.length > 1 ? ' ' + (index + 1) : '');
      link.addEventListener('click', function () {
        emit('assistant_tracking_clicked', { carrier: item.company || '' });
      });
      list.appendChild(link);
    });
    if (list.childNodes.length) stack.appendChild(list);
  }

  function appendSuggestedReplies(stack, response) {
    if (!Array.isArray(response && response.suggested_replies) || !response.suggested_replies.length) return;
    var replies = document.createElement('div');
    replies.className = 'devid-assistant-v2__replies';
    response.suggested_replies.slice(0, 4).forEach(function (replyText) {
      if (!replyText || typeof replyText !== 'string') return;
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'devid-assistant-v2__reply';
      button.textContent = replyText;
      button.addEventListener('click', function () {
        sendMessage(replyText, { source: 'suggested_reply' });
      });
      replies.appendChild(button);
    });
    if (replies.childNodes.length) stack.appendChild(replies);
  }

  function appendAssistantMessage(response) {
    var article = document.createElement('article');
    article.className = 'devid-assistant-v2__message devid-assistant-v2__message--assistant';

    var stack = document.createElement('div');
    stack.className = 'devid-assistant-v2__message-stack';

    var bubble = document.createElement('div');
    bubble.className = 'devid-assistant-v2__bubble';

    if (response.title && response.title !== response.message) {
      var title = document.createElement('strong');
      title.className = 'devid-assistant-v2__bubble-title';
      title.textContent = response.title;
      bubble.appendChild(title);
    }

    var message = document.createElement('p');
    message.textContent = response.message || copy.invalid;
    bubble.appendChild(message);
    stack.appendChild(bubble);

    appendTracking(stack, response);
    appendProducts(stack, response);
    appendPrimaryCta(stack, response);
    appendSuggestedReplies(stack, response);

    article.appendChild(stack);
    messagesNode.appendChild(article);
    announce(response.message || copy.invalid);
    scrollToLatest();
  }

  function appendErrorMessage(message) {
    appendAssistantMessage({ ok: true, type: 'error', title: '', message: message || copy.error });
  }

  function trimMessages() {
    if (state.messages.length > 10) state.messages = state.messages.slice(-10);
  }

  async function getCartContext() {
    try {
      var rootUrl = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
      var response = await fetch(rootUrl + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } });
      if (!response.ok) return [];
      var cart = await response.json();
      if (!cart || !Array.isArray(cart.items)) return [];
      return cart.items.slice(0, 10).map(function (item) {
        return {
          vendor: item.vendor || '',
          product_type: item.product_type || '',
          title: item.product_title || item.title || '',
          variant: item.variant_title || ''
        };
      });
    } catch (error) {
      return [];
    }
  }

  async function requestAssistant(query) {
    if (!endpoint) throw new Error('assistant_endpoint_missing');
    var controller = new AbortController();
    var timeout = window.setTimeout(function () { controller.abort(); }, 10000);
    var cartContext = await getCartContext();

    try {
      var response = await fetch(endpoint, {
        method: 'POST',
        mode: 'cors',
        credentials: 'omit',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        signal: controller.signal,
        body: JSON.stringify({
          query: query,
          message: query,
          messages: state.messages.slice(-10),
          conversation_state: state.conversationState,
          locale: locale,
          language: language,
          country: country,
          path: window.location.pathname,
          page_context: {
            page_type: pageType || 'storefront',
            path: window.location.pathname,
            locale: locale,
            language: language
          },
          cart_context: cartContext,
          knowledge_version: 'assistant-v2'
        })
      });

      if (!response.ok) throw new Error('assistant_http_' + response.status);
      var payload = await response.json();
      if (!payload || payload.ok !== true || typeof payload.message !== 'string' || !payload.message.trim()) throw new Error('assistant_invalid_contract');
      return payload;
    } finally {
      window.clearTimeout(timeout);
    }
  }

  async function sendMessage(rawText, metadata) {
    var text = (rawText || '').toString().trim().slice(0, 500);
    if (!text || state.busy) return;

    root.classList.add('has-conversation');
    if (quickStrip) quickStrip.hidden = false;
    appendUserMessage(text);
    state.messages.push({ role: 'user', content: text });
    trimMessages();
    input.value = '';
    setBusy(true);
    appendTyping();
    emit('assistant_message_sent', {
      source: metadata && metadata.source ? metadata.source : 'composer',
      action: metadata && metadata.action ? metadata.action : ''
    });

    try {
      var response = await requestAssistant(text);
      removeTyping();
      if (response.conversation_state && typeof response.conversation_state === 'object') state.conversationState = response.conversation_state;
      state.messages.push({ role: 'assistant', content: response.message });
      trimMessages();
      appendAssistantMessage(response);
      emit('assistant_response_received', {
        response_type: response.type || '',
        intent: response.intent || (response.normalized_query && response.normalized_query.intent) || '',
        has_products: collectProducts(response).length > 0,
        order_status: response.order_lookup && response.order_lookup.status ? response.order_lookup.status : ''
      });
    } catch (error) {
      removeTyping();
      appendErrorMessage(copy.error);
      emit('assistant_error', { reason: error && error.name === 'AbortError' ? 'timeout' : 'request_failed' });
    } finally {
      setBusy(false);
      input.focus({ preventScroll: true });
    }
  }

  function resetConversation(announceReset) {
    state.messages = [];
    state.conversationState = null;
    state.busy = false;
    removeTyping();
    messagesNode.innerHTML = '';
    root.classList.remove('has-conversation');
    if (quickStrip) quickStrip.hidden = true;
    input.value = '';
    setBusy(false);
    if (announceReset) announce(copy.reset);
    emit('assistant_reset');
  }

  function trapFocus(event) {
    if (!state.open || event.key !== 'Tab') return;
    var focusable = panel.querySelectorAll('button:not([disabled]), a[href], input:not([disabled]), [tabindex]:not([tabindex="-1"])');
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  launcher.addEventListener('click', function () { setOpen(true); });
  if (closeButton) closeButton.addEventListener('click', function () { setOpen(false); });
  if (backdrop) backdrop.addEventListener('click', function () { setOpen(false); });
  if (resetButton) resetButton.addEventListener('click', function () { resetConversation(true); });

  root.querySelectorAll('[data-assistant-prompt]').forEach(function (button) {
    button.addEventListener('click', function () {
      var prompt = button.getAttribute('data-assistant-prompt') || button.textContent || '';
      sendMessage(prompt, { source: 'quick_action', action: button.getAttribute('data-assistant-action') || '' });
    });
  });

  form.addEventListener('submit', function (event) {
    event.preventDefault();
    sendMessage(input.value, { source: 'composer' });
  });

  document.addEventListener('keydown', function (event) {
    if (!state.open) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      setOpen(false);
      return;
    }
    trapFocus(event);
  });

  window.DevidAssistantV2 = {
    open: function () { setOpen(true); },
    close: function () { setOpen(false); },
    reset: function () { resetConversation(true); },
    send: function (message) {
      if (!state.open) setOpen(true);
      sendMessage(message, { source: 'external' });
    }
  };
})();
